import {
  createRouter,
  createWebHistory,
  type NavigationGuardReturn,
  type RouteLocationNormalized,
} from 'vue-router'
import { usePublicLinkApi } from '@/services/publicLinkService'
const GenaView = () => import('@/views/GenaView.vue')
const GenaPaymentLinkView = () => import('@/views/GenaPaymentLinkView.vue')
const GenaQuoteSelectionView = () => import('@/views/GenaQuoteSelectionView.vue')
const HomeView = () => import('@/views/HomeView.vue')
const publicLinkApi = usePublicLinkApi()

function normalizeRouteToken(value: unknown) {
  return typeof value === 'string' ? value.trim() : ''
}

async function resolveTokenRouteByGrantType(
  to: RouteLocationNormalized,
): Promise<NavigationGuardReturn> {
  const token = normalizeRouteToken(to?.params?.token)
  if (!token) return true

  try {
    const resolvedLink = await publicLinkApi.resolveAccessLink(token)
    if (!resolvedLink) return true

    const targetRoute =
      typeof resolvedLink.clientRoute === 'string' ? resolvedLink.clientRoute.trim() : ''
    if (!targetRoute || targetRoute === to.path) return true

    return {
      path: targetRoute,
      query: to.query,
      hash: to.hash,
      replace: true,
    }
  } catch {
    return true
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: { title: 'InforceIQ' },
    },
    {
      path: '/token/:token',
      name: 'intake',
      component: GenaView,
      meta: { title: 'InforceIQ' },
      beforeEnter: resolveTokenRouteByGrantType,
    },
    {
      path: '/payment/:token',
      name: 'payment',
      component: GenaPaymentLinkView,
      meta: { title: 'InforceIQ Payment' },
    },
    {
      path: '/quote-selection/:token',
      name: 'quote-selection',
      component: GenaQuoteSelectionView,
      meta: { title: 'InforceIQ Quote Selection' },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: HomeView,
      meta: { title: 'InforceIQ' },
    },
  ],
})

export default router
